/**
 * CommentReload
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentReload {

	public onReload: any;

	private $parent: any;

	private _id: string;

	private articleId: string;

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.articleId = articleId || Util.getParams().articleId;
		this.onReload = new Util.Observer();
		this.addEvent();
	}

	public remove( commentId: any, $removeNode: any ) {
		const _post = Util.get( Config.commentRemove({
			board: Config.board,
			articleId: this.articleId,
			commentId,
		}), 'DELETE' );
		const _post$ = Util.from( _post );
		_post$.subscribe( ( data: any ) => {
			$removeNode.remove();
		}, ( data: any ) => {
			Config.apiError( data );
		});
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .co-btn-reload`, ( evt ) => {
			this.onReload.emit();
		});
	}
}

export default CommentReload;
